<template>
  <div class="modal modal-xl" tabindex="-1" id="modal-monitor-detail">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Detalhes da ordem de Serviço</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" v-if="loading">
          <div class="progress" style="height: 40px">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated align-middle"
              role="progressbar"
              aria-valuenow="75"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width: 100%"
            ></div>
          </div>
        </div>
        <div class="modal-body" v-else>
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"
                  >CÓD. LAVAGEM:</span
                >
                <input
                  type="text"
                  class="form-control"
                  :value="detail.id"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"
                  >NÚMERO OS:</span
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="detail.os_number"
                />
                <span
                  class="input-group-text bg-success cursor-pointer"
                  style="max-width: 50px"
                  v-on:click="addOsNumber(detail.id)"
                >
                  <i class="material-icons inline-icon text-white">save</i>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">VEÍCULO:</span>
                <input
                  type="text"
                  class="form-control"
                  :value="detail.vehicle"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"
                  >CONSULTOR:</span
                >
                <input
                  type="text"
                  class="form-control"
                  :value="detail.customer"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">EMISSÃO:</span>
                <input
                  type="text"
                  class="form-control"
                  :value="detail.hora_emissao_f"
                  disabled
                />
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1">ENTREGA:</span>
                <input
                  type="text"
                  class="form-control"
                  :value="detail.hora_entrega_f"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <label class="input-group-text" for="inputGroupSelect01"
                  >PRIORIDADE:</label
                >
                <select
                  class="form-select"
                  id="select-prioridade"
                  v-on:change="updatePriority(detail.id)"
                  disabled
                >
                  <option value="1" :selected="detail.priority === 1">
                    Baixa
                  </option>
                  <option value="2" :selected="detail.priority === 2">
                    Padrão
                  </option>
                  <option value="3" :selected="detail.priority === 3">
                    Alta
                  </option>
                  <option value="4" :selected="detail.priority === 4">
                    Urgente
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text">PLACA:</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="detail.plate"
                  v-mask="'AAA#X##'"
                  v-on:blur="detail.plate = detail.plate.toUpperCase()"
                />
                <span
                  class="input-group-text bg-success cursor-pointer"
                  style="max-width: 50px"
                  v-on:click="addPlate(detail.id)"
                >
                  <i class="material-icons inline-icon text-white">save</i>
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 col-12">
              <div class="input-group mb-3" v-if="updatePrism">
                <label class="input-group-text">PRISMA:</label>
                <select
                  v-model="prismColor"
                  class="form-select"
                  style="width: 30%"
                >
                  <option value=""></option>
                  <option :value="p.name" v-for="p in prisms">
                    {{ p.name }}
                  </option>
                </select>
                <input
                  type="text"
                  id="form-plate"
                  v-mask="'##'"
                  class="form-control"
                  v-model="prismNumber"
                  :disabled="prismColor.length <= 0"
                />
                <span
                  class="input-group-text bg-success cursor-pointer"
                  style="max-width: 50px"
                  v-on:click="addPrism(detail.id)"
                >
                  <i class="material-icons inline-icon text-white">save</i>
                </span>
                <span
                  class="input-group-text bg-primary cursor-pointer"
                  style="max-width: 50px"
                  v-on:click="this.updatePrism = false"
                >
                  <i class="material-icons inline-icon text-white">cancel</i>
                </span>
              </div>
              <div class="input-group mb-3" v-else>
                <label class="input-group-text">PRISMA:</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="detail.prism"
                  disabled
                />
                <span
                  class="input-group-text bg-primary cursor-pointer"
                  style="max-width: 50px"
                  v-on:click="this.updatePrism = true"
                >
                  <i class="material-icons inline-icon text-white">edit</i>
                </span>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text">CHASSI:</span>
                <input
                  type="number"
                  class="form-control"
                  v-model="detail.chassis_number"
                />
                <span
                  class="input-group-text bg-success cursor-pointer"
                  style="max-width: 50px"
                  v-on:click="addChassis(detail.id)"
                >
                  <i class="material-icons inline-icon text-white">save</i>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-12">
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"
                  >CADASTRANTE:</span
                >
                <input
                  type="text"
                  class="form-control"
                  :value="detail.created_by_name"
                  disabled
                />
              </div>
            </div>
          </div>

          <h5>Histórico</h5>
          <table class="table">
            <thead>
              <tr>
                <th>Usuário</th>
                <th>Local</th>
                <th>Hora de entrada</th>
                <th>Tempo gasto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="up in detail.updates">
                <td>{{ up.updated_by_name }}</td>
                <td>{{ up.status_new_f }}</td>
                <td>{{ up.created_at_f }}</td>
                <td>{{ up.minutes_expend }}</td>
              </tr>
            </tbody>
          </table>
          <h5 v-if="detail.origin === 3">Alterações de prioridade</h5>
          <h5 v-if="detail.origin === 2">Acessórios</h5>
          <table class="table">
            <thead>
              <tr>
                <th>Usuário</th>
                <th v-if="detail.origin === 3">Motivo</th>
                <th v-if="detail.origin === 2">Acessórios</th>
                <th>Hora</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="up in detail.priority_updates">
                <td>{{ up.name }}</td>
                <td>{{ up.reason }}</td>
                <td>{{ up.created_at_f }}</td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-12">
              <button
                class="btn btn-secondary mx-1"
                id="change-services"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#update-services"
                aria-expanded="false"
                aria-controls="update-services"
                v-if="detail.status === -2 || detail.status === 3"
              >
                Alterar serviços
              </button>
              <button
                class="btn btn-primary mx-1"
                id="change-priority"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#update-priority"
                aria-expanded="false"
                aria-controls="update-priority"
              >
                Alterar a prioridade
              </button>
              <button
                class="btn btn-primary mx-1"
                id="change-delivery"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#update-delivery"
                v-on:click="checkTime(true)"
                v-if="
                  (detail.status === -2 || detail.status === 3) &&
                  detail.origin != 2
                "
              >
                Alterar horário de entrega
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <!--<button class="btn btn-primary" id="change-priority" type="button" data-bs-toggle="collapse"
                      data-bs-target="#update-priority" aria-expanded="false" aria-controls="update-priority">
                Alterar a prioridade
              </button>-->

              <div class="collapse mt-3" id="update-priority">
                <div class="input-group mb-3">
                  <label class="input-group-text" for="inputGroupSelect01"
                    >PRIORIDADE</label
                  >
                  <select
                    class="form-select"
                    id="select-prioridade"
                    v-model="priority"
                  >
                    <option value="1" :selected="detail.priority === 1">
                      Baixa
                    </option>
                    <option value="2" :selected="detail.priority === 2">
                      Padrão
                    </option>
                    <option value="3" :selected="detail.priority === 3">
                      Alta
                    </option>
                    <option value="4" :selected="detail.priority === 4">
                      Urgente
                    </option>
                  </select>
                </div>
                <div class="input-group">
                  <span class="input-group-text">Justificativa</span>
                  <textarea
                    class="form-control"
                    aria-label="With textarea"
                    v-model="priorityReason"
                  ></textarea>
                </div>
                <button
                  class="btn btn-success mt-3"
                  v-on:click="updatePriority(detail.id)"
                >
                  Salvar prioridade
                  <i class="material-icons inline-icon">save</i>
                </button>
              </div>
            </div>

            <!-- previsão de entrega -->
            <div
              class="col-12 mb-3"
              v-if="
                (detail.status === -2 || detail.status === 3) &&
                detail.origin != 2
              "
            >
              <!--<button class="btn btn-primary" id="change-delivery" type="button" data-bs-toggle="collapse"
                      data-bs-target="#update-delivery" v-on:click="checkTime(true)">
                Alterar horário de entrega
              </button>-->

              <div class="collapse mt-3" id="update-delivery">
                <div class="input-group mb-3">
                  <span class="input-group-text">ENTREGA:</span>
                  <input
                    type="date"
                    id="form-delivery-date"
                    class="form-control"
                    v-model="deliveryDate"
                    v-on:blur="checkTime"
                  />
                  <select v-model="deliveryTime" class="form-select" disabled>
                    <option
                      :value="sch.schedule"
                      v-for="sch in deliveryScheduleUsed"
                    >
                      {{ sch.schedule }}
                    </option>
                  </select>
                  <span
                    class="input-group-text cursor-pointer bg-success"
                    v-on:click="checkTime"
                    style="width: 50px"
                  >
                    <i class="material-icons text-white">sync</i>
                  </span>
                </div>
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th>Hora</th>
                      <th class="text-center">Veículos agendados</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="currentPicture.length <= 0">
                      <td colspan="99">
                        Não há nenhum horário aberto para o dia selecionado
                      </td>
                    </tr>
                    <tr v-if="loadingTime">
                      <td colspan="99">
                        <div class="progress">
                          <div
                            class="progress-bar progress-bar-striped progress-bar-animated"
                            role="progressbar"
                            style="width: 100%"
                          ></div>
                        </div>
                      </td>
                    </tr>
                    <tr
                      class="align-middle"
                      v-else
                      v-for="time in currentPicture"
                      :class="getClassByQuantity(time.promised, time.limit)"
                    >
                      <td>{{ time.time }}</td>
                      <td class="text-center">{{ time.promised }}</td>
                      <td class="text-end">
                        <button
                          class="btn pb-0"
                          :class="
                            getClassByQuantity(time.promised, time.limit) ===
                            'table-danger'
                              ? 'btn-secondary'
                              : 'btn-primary'
                          "
                          :disabled="
                            getClassByQuantity(time.promised, time.limit) ===
                            'table-danger'
                          "
                          v-on:click="
                            deliveryTime = time.time.substring(
                              time.time.length - 5,
                            );
                            this.updateDelivery(detail.id);
                          "
                        >
                          <i class="material-icons my-0">
                            {{
                              getClassByQuantity(time.promised, time.limit) ===
                              "table-danger"
                                ? "event_busy"
                                : "event_available"
                            }}
                          </i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!--<button class="btn btn-success mt-3 float-end" v-if="deliveryTime.length > 0" v-on:click="updateDelivery(detail.id)">
                  Salvar novo horário
                </button>-->
              </div>
            </div>

            <div class="col-12 mb-3">
              <div class="collapse mt-3" id="update-services">
                <div class="row">
                  <div class="col-lg-6 col-12">
                    <table class="table mb-0">
                      <thead>
                        <tr>
                          <th class="text-center table-secondary" colspan="5">
                            Serviços disponíveis
                          </th>
                        </tr>
                        <tr>
                          <th>Serviço</th>
                          <th>Tempo estimado</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="99">
                            <input type="text" class="form-control" placeholder="Digite para filtrar" v-model="filterText">
                          </td>
                        </tr>
                        <tr class="align-middle modal-table-update-services" v-for="s in filteredServices">
                          <td>{{ s.name }}</td>
                          <td>{{ s.minutes_to_apply }}</td>
                          <td class="text-end">
                            <button
                              class="btn btn-primary"
                              v-on:click="addService(s)"
                            >
                              <i class="material-icons mt-1">add_circle</i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-lg-6 col-12">
                    <table class="table mb-0">
                      <thead>
                        <tr>
                          <th class="text-center table-primary" colspan="5">
                            Serviços solicitados
                          </th>
                        </tr>
                        <tr>
                          <th>Serviço</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="align-middle" v-for="sa in detail.services">
                          <td>{{ sa.name }}</td>
                          <td class="text-end">
                            <button
                              class="btn btn-danger"
                              v-on:click="removeService(sa)"
                            >
                              <i class="material-icons mt-1">delete</i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="bg-light p-3">
                  <button class="btn btn-success" v-on:click="updateServices()">
                    Salvar serviços
                    <i class="material-icons inline-icon">save</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!--<button class="btn btn-success float-start" id="return-os" type="button"
                  v-on:click="backToWaitingQueue(detail.id)" v-if="detail.status === 1">
            Voltar para aguardando
          </button>-->

          <button class="btn btn-info" type="button" v-if="showCertificateBtn" @click="toCertificate(detail.id)" >
            Emitir certificado
          </button>

          <!--<router-link :to="'/pesquisar-os/'+detail.id" class="btn btn-info" v-if="showCertificateBtn" data-bs-dismiss="modal">
            Emitir certificado
          </router-link>-->

          <button
            class="btn btn-success"
            id="deliver-os"
            type="button"
            v-on:click="deliverVehicle(detail.id)"
            v-if="detail.status === 4"
          >
            Confirmar entrega
          </button>

          <button
            class="btn btn-danger"
            id="cancel-os"
            type="button"
            data-bs-target="#cancel-os"
            v-on:click="cancelOs(detail.id)"
            v-if="detail.status === -2 || detail.status === 3"
          >
            Cancelar serviço
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Helper from "@/components/Helper.vue";
import { mask } from "vue-the-mask";
import router from "@/router";

export default {
  name: "ModalMonitor",
  props: {
    detail: {},
    loading: true,
    services: Array,
  },
  directives: {
    mask,
  },
  computed: {
    filteredServices() {
      if (!this.filterText){
        return this.services
      }
      return this.services.filter(s => (s.name || '').toLowerCase().includes(this.filterText.toLowerCase()));
    },
    showCertificateBtn() {
      if( this.user.admin === false ) {
        return false
      }
      if( this.detail.updates ) {
        for(let upd of this.detail.updates) {
          if( upd.status_new === 4 ) {
            return true
          }
        }
      }

      return false
    }
  },
  data() {
    return {
      filterText: "",
      priority: 2,
      priorityReason: "",
      newDeliveryDate: "",
      prismColor: "",
      prismNumber: "",
      updatePrism: false,
      loadingTime: false,
      currentPicture: [],
      deliveryScheduleUsed: [],
      deliveryDate: "",
      deliveryTime: "",
      user: {},
      //servicesAdded: [],
      //services: [],
    };
  },
  mounted() {
    Helper.checkLogin();

    this.getPrisms();

    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    if (day < 10) {
      day = "0" + day;
    }

    this.deliveryDate = year + "-" + month + "-" + day;

    let user = sessionStorage.getItem("user")
    if( user ) {
      this.user = JSON.parse(user);
    }

    //this.getScheduleUsed()
  },
  methods: {
    toCertificate(id) {
      $("#modal-monitor-detail").modal("hide");
      router.push("/pesquisar-os/" + id + "?certificados=1")
    },
    getScheduleUsed() {
      let tmpSchUsed = sessionStorage.getItem("tmp_schedule_used");
      if (tmpSchUsed) {
        this.deliveryScheduleUsed = JSON.parse(tmpSchUsed);
        return;
      }

      Helper.axiosRequest({
        url: "/manager/schedule-used",
        onFail: (err) => {
          this.loadingTime = false;
          console.log(err);
          let msg = "";
          if (err.response.data.message) {
            msg = err.response.data.message;
          }
          Swal.fire({
            icon: "error",
            title: "Ocorreu um erro",
            html: msg,
          });
        },
        onSuccess: (res) => {
          this.loadingTime = false;
          this.deliveryScheduleUsed = res.data.list;
        },
      });
    },
    async updatePriority(id) {
      Helper.axiosRequest({
        url: "/admin/priority/" + id,
        body: {
          priority: this.priority,
          reason: this.priorityReason,
        },
        method: "put",
        onFail: (err) => {
          console.log(err);

          Swal.fire({
            title: "Ocorreu um erro",
            html: err.response.data.message,
            icon: "error",
          });
        },
        onSuccess: () => {
          Swal.fire({
            icon: "success",
            title: "Prioridade alterada",
          }).then(() => {
            this.$parent.getOsDetail(id);
            this.$parent.getMonitorData(true);
            //this.$parent.getMonitorWaiting()

            $("#change-priority").click();
            this.priorityReason = "";
          });
        },
      });
    },
    addPlate(id) {
      Helper.axiosRequest({
        url: "/admin/car/" + id + "/add-plate",
        method: "patch",
        body: { plate: this.detail.plate },
        onSuccess: (r) => {
          this.$parent.getOsDetail(id);
          Swal.fire({
            icon: "success",
            title: "Placa de veículo alterada",
          });
        },
      });
    },
    addPrism(id) {
      Helper.axiosRequest({
        url: "/admin/car/" + id + "/add-prism",
        method: "patch",
        body: { prism: this.prismColor + " " + this.prismNumber },
        onSuccess: (r) => {
          this.$parent.getOsDetail(id);
          Swal.fire({
            icon: "success",
            title: "Prisma de veículo alterado",
          });
        },
      });
    },
    addChassis(id) {
      Helper.axiosRequest({
        url: "/admin/car/" + id + "/add-chassis",
        method: "patch",
        body: { chassis_number: this.detail.chassis_number },
        onSuccess: (r) => {
          console.log(r);
          Swal.fire({
            icon: "success",
            title: "Prisma de veículo alterado",
          });
        },
      });
    },
    addOsNumber(id) {
      console.log(this.detail);
      Helper.axiosRequest({
        url: "/admin/car/" + id + "/add-osnumber",
        method: "patch",
        body: { os_number: this.detail.os_number },
        onSuccess: (r) => {
          console.log(r);
          Swal.fire({
            icon: "success",
            title: "Número do OS alterado",
          });
        },
      });
    },
    cancelOs(id) {
      Swal.fire({
        title: "Cuidado",
        text: "Essa OS será cancelada e não poderá mais ser atualizada. Essa ação não pode ser desfeita",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#707070",
        confirmButtonText: "Sim, cancelar OS",
        cancelButtonText: "Deixar OS ativa",
      }).then((result) => {
        if (result.isConfirmed) {
          Helper.axiosRequest({
            url: "/admin/car/" + id,
            method: "delete",
            onFail: (err) => {
              console.log(err);

              Swal.fire({
                title: "Ocorreu um erro inesperado",
                html: err.response.data.message,
                icon: "error",
              });
            },
            onSuccess: () => {
              Swal.fire({
                icon: "success",
                title: "OS cancelada",
              }).then(() => {
                //this.$parent.getOsDetail(id)
                //this.$parent.getMonitorData(true)

                $("#modal-monitor-detail").modal("hide");
              });
            },
          });
        }
      });
    },
    updateDelivery(id) {
      if (this.deliveryTime.length <= 0) {
        Swal.fire("Adicione uma hora");

        return;
      }
      if (this.deliveryDate.length <= 0) {
        Swal.fire("Adicione o dia para a entrega");

        return;
      }

      this.newDeliveryDate = this.deliveryDate + " " + this.deliveryTime;
      //console.log(this.newDeliveryDate); return;

      Helper.axiosRequest({
        url: "/admin/car/" + id + "/delivery-date",
        method: "put",
        body: { date: this.newDeliveryDate },
        onFail: (err) => {
          console.log(err);

          Swal.fire({
            title: "Ocorreu um erro",
            html: err.response.data.message,
            icon: "error",
          });
        },
        onSuccess: () => {
          Swal.fire({
            icon: "success",
            title: "Previsão de entrega atualizada",
          }).then(() => {
            this.$parent.getOsDetail(id);
            //this.$parent.getMonitorData(true)

            //$('#modal-monitor-detail').modal("hide")
          });
        },
      });
    },
    deliverVehicle(id) {
      Helper.axiosRequest({
        url: "/admin/car/" + id + "/confirm-delivery",
        method: "patch",
        onFail: (err) => {
          console.log(err);

          Swal.fire({
            title: "Ocorreu um erro",
            html: err.response.data.message,
            icon: "error",
          });
        },
        onSuccess: () => {
          Swal.fire({
            icon: "success",
            title: "Veículo entregue",
          }).then(() => {
            //this.$parent.getOsDetail(id)
            this.$parent.getMonitorData(true);

            $("#modal-monitor-detail").modal("hide");
          });
        },
      });
    },
    getPrisms() {
      let tmpPrism = sessionStorage.getItem("tmp_prisms");
      if (tmpPrism) {
        this.prisms = JSON.parse(tmpPrism);
        return;
      }

      Helper.axiosRequest({
        url: "/manager/prism",
        onFail: (err) => {
          console.log(err);
          let msg = "";
          if (err.response.data.message) {
            msg = err.response.data.message;
          }
          Swal.fire({
            icon: "error",
            title: "Ocorreu um erro",
            html: msg,
          });
        },
        onSuccess: (res) => {
          sessionStorage.setItem("tmp_prisms", JSON.stringify(res.data.list));
          this.prisms = res.data.list;
        },
      });
    },
    backToWaitingQueue(id) {
      Swal.fire({
        title: "Voltar?",
        text: 'Esse veículo sairá da lista de veículos para lavagem e irá para "Esperando lavagem"',
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#198754",
        cancelButtonColor: "#707070",
        confirmButtonText: "Sim, voltar",
        cancelButtonText: "Deixar na fila",
      }).then((result) => {
        if (result.isConfirmed) {
          Helper.axiosRequest({
            url: "/admin/status/" + id,
            method: "patch",
            body: { status: -2 },
            onFail: (err) => {
              console.log(err);

              Swal.fire({
                title: "Ocorreu um erro inesperado",
                html: err.response.data.message,
                icon: "error",
              });
            },
            onSuccess: () => {
              Swal.fire({
                icon: "success",
                title: "Veículo voltou para fila de espera",
              }).then(() => {
                this.$parent.getOsDetail(id);
                this.$parent.getMonitorData(true);
                //this.$parent.getMonitorWaiting()

                $("#modal-monitor-detail").modal("hide");
              });
            },
          });
        }
      });
    },
    checkTime(silent) {
      if (!silent) {
        this.loading = true;
      }

      this.loadingTime = true;
      Helper.axiosRequest({
        url:
          "/admin/by-hour?hour=" +
          this.deliveryDate +
          "&origin=" +
          this.detail.origin,
        onSuccess: (r) => {
          this.loadingTime = false;
          this.currentPicture = r.data.list;
        },
        onFail: (err) => {
          this.loadingTime = false;
          console.log(err);
          Swal.fire({
            icon: "error",
            title: "Ocorreu um erro inesperado",
          });
        },
      });
    },
    getClassByQuantity(qtd, limit) {
      if (this.detail.origin === 2) {
        if (qtd >= limit) {
          return "table-danger";
        }
        if (qtd > 0 && qtd === limit - 1) {
          return "table-warning";
        }

        return "table-success";
      }

      if (qtd >= limit) {
        return "table-danger";
      }
      if (qtd === limit - 1) {
        return "table-warning";
      }
      if (qtd >= 1 && limit - 1) {
        return "table-success";
      }

      return "";
    },
    isServiceAdded(serv) {
      for (let i = 0; i < this.detail.services.length; i++) {
        if (this.detail.services[i].name == serv.name) {
          return true;
        }

        return false;
      }
      //console.log(serv)
    },
    addService(serv) {
      for (let i = 0; i < this.detail.services.length; i++) {
        if (serv.name == this.detail.services[i].name) {
          return;
        }
      }

      this.detail.services.push(serv);
    },
    removeService(serv) {
      let newServices = [];
      for (let i = 0; i < this.detail.services.length; i++) {
        if (serv.name !== this.detail.services[i].name) {
          newServices.push(this.detail.services[i]);
        }
      }

      //console.log(newServices)
      this.detail.services = newServices;
    },
    updateServices() {
      if (this.detail.services.length <= 0) {
        Swal.fire({
          icon: "warning",
          title: "Adicione um serviço",
          html: "Adicione pelo menos um serviço para enviar para a lavagem",
        });
        return;
      }

      Helper.axiosRequest({
        url: "/admin/car/" + this.detail.id + "/update-services",
        method: "put",
        body: { services: this.detail.services },
        onSuccess: () => {
          Swal.fire({
            icon: "success",
            title: "Atualizado",
            html: "Serviços solicitados para lavação atualizados com sucesso",
          });
          this.$parent.getOsDetail(this.detail.id);
          this.$parent.getMonitorData(true);
        },
      });
    },
  },
};
</script>

<style scoped>
.input-group-text {
  width: 140px;
  font-weight: 600;
}
</style>
